<template>
<h1 class="display-2 text-light text-center">National Ice Cream month</h1>
  <div class="card">
    <div class="card-body row">
      <div class="col-lg-8">
      <h5>National Ice Cream Month is celebrated each year in July and National Ice Cream Day is celebrated on Sunday, July
      18. The celebrations were originated by Joint resolution 298 in the United States Senate, which was sponsored by
      Senator Walter Dee Huddleston of Kentucky on May 17, 1984, and Joint resolution 543 in the United States House of
      Representatives, which was sponsored by Representative Kika de la Garza of Texas on April 11, 1984. The resolution
      proclaimed the month of July 1984 as "National Ice Cream Month" and July 15, 1984, as "National Ice Cream Day". It
      was signed into public law by President Ronald Reagan on July 9, 1984, with Presidential Proclamation 5219.</h5>
    </div>
    <div class="col-lg-4">
      <img class="float-right rounded" src="https://media.giphy.com/media/3o6Zt7qChPzoAUAmpW/giphy.gif">
    </div>
    </div>
  </div>
<h5 class="display-4 text-light text-center">Have fun making your own Ice Cream combos!</h5>
</template>